import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Clock, User } from "lucide-react";
import Footer from "@/components/Footer";
import { SCIENCE_ARTICLES } from "@/data/scienceArticles";

export default function ScienceIndex() {
  return (
    <div className="bg-[#050505] min-h-screen" data-testid="science-index">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/90 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
          <Link to="/" className="font-brand text-2xl tracking-tighter text-white">FYB</Link>
          <span className="text-xs tracking-[0.15em] uppercase text-[#D4AF37]">The Science</span>
        </div>
      </nav>

      <main className="pt-28 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-16">
            <p className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] font-bold mb-4">Research-Backed</p>
            <h1 className="font-heading text-4xl sm:text-5xl tracking-tighter uppercase text-white mb-4">
              The Science Behind CLARITY
            </h1>
            <p className="text-zinc-400 max-w-2xl text-base leading-relaxed">
              Merls isn't a scientist — so he checked every claim against the researchers and listed them all. These articles break down the real science behind the CLARITY Protocol in plain language, backed by peer-reviewed research.
            </p>
          </div>

          <div className="space-y-6">
            {SCIENCE_ARTICLES.map((post) => (
              <Link
                key={post.slug}
                to={`/science/${post.slug}`}
                className="block border-gold-glow card-hover bg-[#121212] p-6 sm:p-8 rounded-sm group"
                data-testid={`science-card-${post.slug}`}
              >
                <div className="flex items-center gap-4 text-xs text-zinc-500 mb-3">
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {post.date}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {post.readTime}</span>
                  <span className="flex items-center gap-1"><User className="w-3 h-3" /> {post.author}</span>
                </div>
                <h2 className="font-heading text-2xl sm:text-3xl tracking-tight uppercase text-white group-hover:text-[#D4AF37] transition-colors mb-3">
                  {post.title}
                </h2>
                <p className="text-zinc-400 text-sm leading-relaxed mb-4">{post.excerpt}</p>
                <div className="flex items-center gap-4">
                  <span className="text-[#D4AF37] text-xs tracking-[0.15em] uppercase font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read Article <ArrowRight className="w-3 h-3" />
                  </span>
                  <div className="flex gap-2">
                    {post.tags.map((tag) => (
                      <span key={tag} className="text-[9px] tracking-wider uppercase text-zinc-600 border border-white/10 px-2 py-0.5 rounded-sm">{tag}</span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
